import { ResolveFn } from '@angular/router';

export const authDetailsTitleResolver = (pageName: string): ResolveFn<string> =>
  (route) => `${pageName} ${route.paramMap.get('authorizationNumber')}`;
